import { render, staticRenderFns } from "./agv-payment-form.vue?vue&type=template&id=65895349&scoped=true&lang=pug&"
import script from "./agv-payment-form.vue?vue&type=script&lang=js&"
export * from "./agv-payment-form.vue?vue&type=script&lang=js&"
import style0 from "./agv-payment-form.vue?vue&type=style&index=0&id=65895349&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65895349",
  null
  
)

export default component.exports